import React from 'react';
import Navigation from '../components/Navigation';
import HeroStory from '../components/HeroStory';
import StorySection from '../components/StorySection';
import Marquee from '../components/Marquee';
import IngredientsSection from '../components/IngredientsSection';
import ProductShowcase from '../components/ProductShowcase';
import Manifesto from '../components/Manifesto';
import Footer from '../components/Footer';
const Home = () => {

  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--atelier-cream)' }}>
      <Navigation />
      <HeroStory />
      <StorySection />
      <Marquee />
      <IngredientsSection />
      <ProductShowcase />
      <Manifesto />
      <Footer />
    </div>
  );
};

export default Home;